// Anagrafica in tre gruppi affiancati: i campi vuoti restano nascosti,
// quelli che una pratica in corso richiede sono sempre visibili e segnati in arancio.
export default function ClienteAnagrafica({ gruppi, tutti }) {
  return (
    <>
      <div className="grid md:grid-cols-3 gap-4 min-w-0">
        {gruppi.map((g) => {
          const campi = g.campi.filter((c) => tutti || c.valore || c.richiesto_da.length > 0);
          if (campi.length === 0) return null;
          return (
            <div key={g.key} data-testid={`anagrafica-gruppo-${g.key}`} className="sub min-w-0">
              <div className="subt"><span>{g.label}</span></div>
              {campi.map((c, i) => {
                const manca = !c.valore && c.richiesto_da.length > 0;
                return (
                  <div key={c.key} data-testid={`campo-${c.key}`}
                    className={`kv ${manca ? "kv-manca" : i % 2 === 1 ? "kv-zebra" : ""}`}
                    title={manca ? `Richiesto da: ${c.richiesto_da.join(" · ")}` : undefined}>
                    <span>{c.label}</span>
                    <span>{c.valore || (manca ? "da raccogliere" : "—")}</span>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <span className="text-[13px] text-[#4A4A48]">
        I campi vuoti restano nascosti finché non servono. Quelli che una pratica in corso richiede sono segnati in arancio.
      </span>
    </>
  );
}
